import { render } from "./bookCount.vue?vue&type=template&id=514912ba&scoped=true"
import script from "./bookCount.vue?vue&type=script&lang=js"
export * from "./bookCount.vue?vue&type=script&lang=js"

import "./bookCount.vue?vue&type=style&index=0&id=514912ba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-514912ba"]])

export default __exports__